import config from '../config';

export const getAllPaymentLogs = async (params) => {
   // Serialize the query parameters
   const queryString = new URLSearchParams(params).toString();
   console.log(queryString)
     const response = await fetch(`${config.apiUrl}/payment-logs/filter/param=?&${queryString}`, {
       method: "GET",
     });

  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};